import React from 'react';
import Icon from '../../../../../../muiComponents/Icon';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import TextInput from '../../../../../../muiComponents/TextInput/TextInput';

interface ImageItemViewProps {
    src: string;
    caption: string;
    category?: string;
    feature: boolean;
    published: boolean;
    onCaptionChange: (caption: string) => void;
    onFeatureChange: (feature: boolean) => void;
    onPublishedChange: (published: boolean) => void;
    onDelete: () => void;
}

const ImageItemView = ({
    src,
    caption,
    category,
    feature,
    published,
    onCaptionChange,
    onFeatureChange,
    onPublishedChange,
    onDelete,
}: ImageItemViewProps) => {
    return (
        <li className='zitoneo-images-tab__item'>
            <div className='zitoneo-images-tab__image-container'>
                <img
                    src={src}
                    alt={caption}
                    className='zitoneo-images-tab__image'
                />
                {category && (
                    <span className='zitoneo-images-tab__tag'>{category}</span>
                )}
            </div>
            <div className='zitoneo-images-tab__details'>
                <TextInput
                    deleteIcon={false}
                    value={caption}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        onCaptionChange(event.target.value);
                    }}
                    aria-label={caption || 'Image caption'}
                />
                <div className='zitoneo-images-tab__toolbar'>
                    <div className='zitoneo-images-tab__actions'>
                        <Tooltip
                            titleText={
                                published
                                    ? 'published__complete'
                                    : 'published__incomplete'
                            }
                        >
                            <span>
                                <Icon
                                    iconName={
                                        published ? 'CloudDone' : 'CloudOff'
                                    }
                                    className={`zitoneo-images-tab__action${
                                        published ? ' --active' : ''
                                    }`}
                                    onClick={() =>
                                        onPublishedChange(!published)
                                    }
                                />
                            </span>
                        </Tooltip>
                        <Tooltip
                            titleText={
                                feature ? 'fav_image_active' : 'fav_image'
                            }
                        >
                            <span>
                                <Icon
                                    iconName={feature ? 'Star' : 'StarOutline'}
                                    className={`zitoneo-images-tab__action${
                                        feature ? ' --active' : ''
                                    }`}
                                    onClick={() => onFeatureChange(!feature)}
                                />
                            </span>
                        </Tooltip>
                    </div>
                    <Tooltip titleText='delete_image'>
                        <span>
                            <Icon
                                iconName='DeleteOutlined'
                                className='zitoneo-images-tab__action --delete'
                                onClick={onDelete}
                            />
                        </span>
                    </Tooltip>
                </div>
            </div>
        </li>
    );
};

export default ImageItemView;
